<template>
	<div class="cm-car-images-container">
		<div v-if="!loading" class="cm-car-images car-images">
			<div class="images-counter">
				{{ activeThumb + 1 }} / {{ car.imagesTotal }}
			</div>
			<swiper
				class="cm-car-image-box bg-600"
				@slideChange="getCurrentSlide"
				@imagesReady="getSlider"
				:slides-per-view="1"
				navigation
				loop
				lazy
				:thumbs="{ swiper: thumbsSwiper }"
			>
				<swiper-slide v-for="image in car.imagesMain" :key="image" class="">
					<img :src="image" class="cm-car-img-main img-fluid" alt="" />
					<div class="swiper-lazy-preloader d-none"></div>
				</swiper-slide>

				<div
					class="cm-img-watermark"
					:style="'background-image: url(\'' + car.imageWatermark + '\')'"
				></div>
			</swiper>
			<swiper
				class="cm-car-thumb-box"
				@swiper="setThumbsSwiper"
				@imagesReady="getSlider"
				navigation
				watch-slides-visibility
				watch-slides-progress
				:space-between="6"
				:slides-per-view="8"
				:breakpoints="breakpoints"
				lazy
			>
				<swiper-slide
					v-for="(image, i) in car.imagesThumb"
					:key="image"
					class="cm-car-images-thumbs"
				>
					<div class="car-thumb-box" :class="{ active: activeThumb === i }">
						<div class="arrow-up"></div>
						<img
							:src="image"
							class="img-fluid cm-car-image-thumb car-thumb-img"
							alt=""
						/>
					</div>
				</swiper-slide>
			</swiper>
		</div>
	</div>
</template>

<script>
import SwiperCore, {
	Thumbs,
	Lazy,
	Navigation,
	Pagination,
	Scrollbar,
	A11y,
} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([Thumbs, Lazy, Navigation, Pagination, Scrollbar, A11y])

export default {
	name: 'DetailsImages',
	components: {
		Swiper,
		SwiperSlide,
	},
	data() {
		return {
			loading: true,
			settings: {
				itemsToShow: 1,
				centerMode: false,
				preloadImages: false,
				lazy: true,
			},
			firstSwiper: null,
			secondSwiper: null,
			thumbsSwiper: null,
			breakpoints: {
				300: {
					slidesPerView: 5,
				},
				640: {
					slidesPerView: 6,
				},
				992: {
					slidesPerView: 4,
				},
				1200: {
					slidesPerView: 6,
				},
			},
			settingsThumb: {
				itemsToShow: 4,
				centerMode: true,
			},
			activeThumb: 0,
		}
	},
	props: {
		car: Object,
	},
	methods: {
		getCurrentSlide(swiper) {
			this.activeThumb = swiper.realIndex
		},
		setThumbsSwiper(swiper) {
			this.thumbsSwiper = swiper
		},
		getSlider(swiper) {
			this.loading = false
		},
	},
	created() {
		setTimeout(() => {
			this.loading = false
		}, 300)
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/assets/scss/swiper.scss';
@import '../../../node_modules/swiper/components/navigation/navigation.scss';
@import '../../../node_modules/swiper/components/pagination/pagination.scss';
@import '../../../node_modules/swiper/components/scrollbar/scrollbar.scss';
@import '../../../node_modules/swiper/components/lazy/lazy.scss';

.cm-car-images-container {
	position: relative;
	@include media-breakpoint-down(sm) {
		left: -0.75rem;
		padding-right: -0.75rem;
		width: 100vw;
		/*		.swiper-container-thumbs {
			padding-left: 0.75rem;
			padding-right: 0.75rem;
		}*/
	}
}

.cm-car-images {
	position: relative;
	overflow: hidden;
	.images-counter {
		position: absolute;
		top: 4px;
		left: 4px;
		z-index: 2;
		background-color: rgba(23, 23, 23, 0.7);
		color: #fff;
		font-weight: 500;
		padding: $px4 $px8;
		font-size: $px13;
		line-height: $px13;
		border-radius: $border-radius;
	}
	.cm-img-watermark {
		background-position: bottom center;
	}
}
.cm-car-slider {
	position: relative;
	overflow: hidden;
	display: block;

	> ul {
		list-style-type: none;
		padding-left: 0;
		width: auto;
		display: inline-block;
		height: 595px;

		> li {
			display: inline-block;
			float: left;
			width: 795px;

			> img {
				width: 100%;
				height: auto;
			}
		}
	}
}

.cm-car-image-box {
	margin-bottom: 10px;
	position: relative;

	.cm-img-watermark {
		z-index: 10;
		padding-top: 2px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 208px;
		background-color: transparent;
		color: #fff;
		font-family: 'Barlow Semi Condensed';
		font-weight: 700;
		font-size: $px16;
		text-align: center;
		background-size: 100%;
		background-position: bottom center;
		background-repeat: no-repeat;
	}

	// Navigation Arrows

	.swiper-button-prev {
		left: 0 !important;
		border-bottom-right-radius: 40px;
		border-top-right-radius: 40px;
		transition: 0.2s background-color;
		&::after {
			font-family: $font-mdi;
			content: '\F0141';
			margin-right: 5px;
		}
	}
	.swiper-button-next {
		right: 0 !important;
		border-bottom-left-radius: 40px;
		border-top-left-radius: 40px;
		&::after {
			font-family: $font-mdi;
			content: '\F0142';
			margin-left: 5px;
		}
	}

	.swiper-button-prev,
	.swiper-button-next {
		margin-top: -40px !important;
		position: absolute;
		top: 50%;
		height: 80px;
		width: 40px !important;
		opacity: 1;
		background: rgba(0, 0, 0, 0.4) !important;
		z-index: 20;
		@include media-breakpoint-down(sm) {
			opacity: 0;
		}
		&::after {
			font-size: $px32;
			color: #fff;
		}
		&:hover {
			background: rgba(0, 0, 0, 0.6) !important;

			&::after {
				transform: scale(1.2);
				color: #fff;
			}
		}
	}
	.cm-car-img-main {
		min-width: 100%;
	}
}

.cm-car-thumb-box {
	//padding: 0 $px24;
	position: relative;
	.swiper-button-prev {
		left: 0 !important;
		&::after {
			font-size: $px20;
			font-family: $font-mdi;
			content: '\F0141';
			color: #fff;
		}
	}

	.swiper-button-next {
		right: 0 !important;

		&::after {
			font-size: $px20;
			font-family: $font-mdi;
			content: '\F0142';
			color: #fff;
		}
	}

	.swiper-button-prev,
	.swiper-button-next {
		margin-top: 0;
		position: absolute;
		background-color: rgba(0, 0, 0, 0.5) !important;
		border-radius: 0 !important;
		height: auto;
		width: $px24;
		bottom: 0;
		top: 0;
		z-index: 2;
		&:hover {
			background-color: rgba(0, 0, 0, 0.7) !important;
		}
		&.swiper-button-disabled {
			opacity: 0 !important;
		}
	}
}

.cm-car-images-thumbs {
	.car-thumb-box {
		position: relative;
		//border: 2px solid #fff;
		background-color: $gray-400;
		box-sizing: border-box;

		&:hover {
			cursor: pointer;

			.car-thumb-img {
				opacity: 1;
			}
		}

		.car-thumb-img {
			opacity: 0.5;
		}

		&.active {
			border: 2px solid $primary;

			.arrow-up {
				opacity: 1;
			}

			.car-thumb-img {
				opacity: 1;
			}
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all 0.2s ease;
	overflow: hidden;
	visibility: visible;
	position: absolute;
	width: 100%;
	opacity: 1;
}

.fade-enter,
.fade-leave-to {
	visibility: hidden;
	width: 100%;
	opacity: 0;
}

.prev,
.next {
	cursor: pointer;
	position: absolute;
	top: 40%;
	width: auto;
	padding: 16px;
	color: white;
	font-weight: bold;
	font-size: 18px;
	transition: 0.7s ease;
	border-radius: 0 4px 4px 0;
	text-decoration: none;
	user-select: none;
}

.next {
	right: 0;
}

.prev {
	left: 0;
}

.prev:hover,
.next:hover {
	background-color: rgba(0, 0, 0, 0.9);
}
</style>
